import { notification } from "antd"
import { unSubscribeSocketUser, unSubscribeSocketSupport } from "config/socket"
import React from "react"

const hostname = window.location.hostname

const isMrPayCard = process.env.REACT_APP_IS_MRPAY_CARD === "true"
const isStage = process.env.REACT_APP_IS_STAGE === "true"


export const endpoint = isMrPayCard
  ? process.env.REACT_APP_API_ENDPOINT_MRPAYCARD_PRODUCTION
  : hostname.includes("login.mrpay.it") || isStage
  ? process.env.REACT_APP_API_ENDPOINT_STAGE
  : process.env.REACT_APP_API_ENDPOINT_PRODUCTION

export const baseUrlImg = isMrPayCard
  ? process.env.REACT_APP_BASE_URL_IMG_MRPAYCARD
  : hostname.includes("login.mrpay.it") || isStage
  ? process.env.REACT_APP_BASE_URL_IMG_STAGE
  : process.env.REACT_APP_BASE_URL_IMG_PRODUCTION

export const apiUrl = endpoint
window.apiUrl = apiUrl

export const getToken = () => {
  const value = localStorage.getItem("accountDataB")
  const keys = JSON.parse(value)
  return `Bearer ${keys?.token}`
}

export const PROJECT_ID = "e89edb73"

const hasCode = (error, status) => {
  return (
    error?.response?.status === parseInt(status) ||
    error?.error?.response?.status === parseInt(status)
  )
}

export const handleError = (error) => {
  if (hasCode(error, 401)) {
    // logged out
    const profileId = JSON.parse(localStorage.getItem("accountDataB"))?.profile?.id
    if (profileId) unSubscribeSocketUser(profileId)

    const roleName = JSON.parse(localStorage.getItem("accountDataB"))?.profile?.role
      ?.name
    if (roleName === "support") unSubscribeSocketSupport()

    localStorage.setItem("accountDataB", null)
    window.store.dispatch({ type: "SET_UNAUTHORIZATION" })
  } else if (error?.message === "Network Error") {
    notification.error({
      key: "networkErr",
      message: `Non connesso a Internet`,
      icon: <i className="fal fa-wifi-slash"></i>,
      duration: 0,
    })
  } else if (hasCode(error, 445)) {
    // skin id wrong
  } else if (hasCode(error, 440)) {
    localStorage.setItem("accountDataB", null)
    window.store.dispatch({ type: "SET_UNAUTHORIZATION" })
  } else if (hasCode(error, 429)) {
    // too many requests
  } else if (hasCode(error, 403)) {
    notification.warning({ message: `Forbidden` })
  } else if (hasCode(error, 514)) {
    window.location.href = "#/comming-soon"
  } else if (hasCode(error, 422)) {
    const responseData = error?.response?.data
    const errorDetails =
      responseData?.errors || responseData?.error || responseData?.message

    if (errorDetails) {
      let errorMessages = ""
      if (typeof errorDetails === "object") {
        errorMessages = Object.keys(errorDetails)
          .map((field) => `${field}: ${errorDetails[field].join(", ")}`)
          .join("\n")
      } else if (typeof errorDetails === "string") {
        errorMessages = errorDetails
      }

      notification.error({
        message: "Error",
        description: errorMessages,
        placement: window.innerWidth <= 1024 ? "topRight" : "bottomRight",
        duration: 4,
      })
    }
  } else {
    notification.error({
      message: error?.response?.data?.message || "Error",
      description: error?.response?.data?.errors
        ? Object.values(error.response.data.errors)
        : error?.response?.data?.error,
      placement: window.innerWidth <= 1024 ? "topRight" : "bottomRight",
      duration: 4,
    })
  }

  return Promise.reject(error)
}

export let skin = {
  skin_id: localStorage.getItem("skin_id") || "2",
}

export default {
  endpoint,
  baseUrl: apiUrl,
  baseUrlImg,
  headers: {},
}
